import parse from 'html-react-parser';
import Answer from './Answer';

import * as GoogleAnalytics from './Global/GoogleAnalytics'
import { cme_kurs } from './Global/Kurs';

import $ from 'jquery'


export const Question = ({ questionIndex, headline, subheadline, question, answers, legende, rawAnswers, setRawAnswers, setAnswerKey }) => {

    // -- show and hide answers of question
    function toggleQuestionContainer(event) {

        var questionAnswerContainer = event.currentTarget.parentNode.querySelector('.answer-question-container');
        var allAnswerQuestionContainer = document.querySelectorAll('.answer-question-container');

        var thisCollapsible = event.currentTarget.parentNode.querySelector('.collapsible-container');
        var allCollapsible = document.querySelectorAll('.collapsible-container');

        if (questionAnswerContainer.style.display === 'block') {
            // hide these answers
            $(questionAnswerContainer).hide();
            thisCollapsible.setAttribute('active', 'false');
        }
        else {
            // first, hide all answers
            $(allAnswerQuestionContainer).hide();
            allCollapsible.forEach((elem) => {
                elem.setAttribute('active', 'false');
            })
            // show this answer
            $(questionAnswerContainer).show();
            thisCollapsible.setAttribute('active', 'true');

            // send question-click to ga4
            const questionNumber = questionIndex + 1;
            if (cme_kurs) GoogleAnalytics.sendToGa4('fragen_click', { 'frage_nr': questionNumber });
        }


    }

    var answerArray = [];

    for (let i = 0; i < answers.length; i++) {
        // if a answer is empty dont push it into array
        if (answers[i].answertext !== "" && answers[i].answertext !== " ") {
            answerArray.push(
                <Answer key={i} answerIndex={i} questionIndex={questionIndex} answer={answers[i].answertext} rawAnswers={rawAnswers} setRawAnswers={setRawAnswers} setAnswerKey={setAnswerKey} />
            );
        }
    }

    return (
        <a href={"#question-" + questionIndex} id={"question-" + questionIndex} questionnr={questionIndex} className="single-question">

            {/* single question */}
            <div className="questionNr-container" onClick={toggleQuestionContainer}>

                <div
                    // set checkbox active if answer is selected
                    className={`answer-rect-container answer-rect-header ${(rawAnswers[questionIndex] || rawAnswers[questionIndex] === 0) ? 'answer-selected' : 'answer-inactive'}`}
                ></div>

                <div className="question-headline">{headline}:</div> <div className="question-subheadline">{subheadline}</div>
                <div className="collapsible-container" active="false"></div>
            </div>

            {/* all answers */}
            <div className="answer-question-container">
                <div className="question-container ">
                    <div className="question">{parse(question)}</div>
                </div>
                <div className="answer-container">

                    {answerArray}

                </div>
                <div className="legende">{parse(legende)}</div>

            </div>

        </a>
    )
}

export default Question